import { Controller } from "@hotwired/stimulus"

// Simple autocomplete using native <datalist>.
// Usage:
//   data-controller="autocomplete"
//   data-autocomplete-url-value="/master_crops/search_suggestions"
//   The controller will create a datalist and attach it to the input.

export default class extends Controller {
  static values = { url: String }

  connect() {
    this._listId = `autocomplete-${Math.random().toString(36).slice(2)}`
    this._datalist = document.createElement("datalist")
    this._datalist.id = this._listId
    this.element.setAttribute("list", this._listId)
    this.element.after(this._datalist)
    this._boundOnInput = this._onInput.bind(this)
    this.element.addEventListener("input", this._boundOnInput)
  }

  disconnect() {
    this._datalist.remove()
    this.element.removeEventListener("input", this._boundOnInput)
  }

  async _onInput() {
    const q = this.element.value
    if (q.length < 2) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", q)

    const response = await fetch(url, { headers: { "Accept": "application/json" } })
    const suggestions = await response.json()

    this._datalist.innerHTML = suggestions
      .map(s => `<option value="${s}"></option>`)
      .join("")
  }
}
